/**
 * Tracking scripts HTML generator — produces parked tracking scripts
 * v4.2 P0 (Issue 2): Scripts are type="text/plain" until consent
 */
import { esc } from '@/utils/escape';

export function generateTrackingScriptsHTML(settings: any): string {
  const preset = settings?.trackingPreset || 'none';
  const tracking = settings?.tracking || {};

  // v4.2 P0 (Issue 2.1): Export Guard
  const t = (v: any) =>
    typeof v === 'string' ? v.trim() : String(v || '').trim();

  const isValidGa4Id = (v: any) => /^G-[A-Z0-9]+$/i.test(t(v));
  const isValidHttpUrl = (v: any) => /^https?:\/\//i.test(t(v));
  const isValidNumeric = (v: any) => /^\d+$/.test(t(v));

  // No Tracking: export nothing
  if (preset === 'none') return '';

  if (preset === 'ga4') {
    const id = t(tracking.ga4MeasurementId);

    // Guard: invalid or missing ID => export nothing (safe-by-default)
    if (!id || !isValidGa4Id(id)) return '';

    const gtagSrc = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;

    return `
  <!-- Tracking (GA4) — parked until statistics consent -->
  <script type="text/plain" data-consent="statistics" data-src="${esc(gtagSrc)}"><${'/'}script>
  <script type="text/plain" data-consent="statistics">
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', ${JSON.stringify(id)}, { anonymize_ip: true });
  <${'/'}script>`;
  }

  if (preset === 'matomo') {
    const baseUrlRaw = t(tracking.matomoUrl);
    const siteIdRaw = t(tracking.matomoSiteId);

    // Guard: invalid or missing config => export nothing
    if (
      !baseUrlRaw ||
      !siteIdRaw ||
      !isValidHttpUrl(baseUrlRaw) ||
      !isValidNumeric(siteIdRaw)
    )
      return '';

    const baseUrl = baseUrlRaw.replace(/\/+$/, '') + '/';
    const siteId = Number(siteIdRaw);
    const matomoJs = baseUrl + 'matomo.js';
    const matomoPhp = baseUrl + 'matomo.php';

    return `
  <!-- Tracking (Matomo Self-Host) — parked until statistics consent -->
  <script type="text/plain" data-consent="statistics">
    window._paq = window._paq || [];
    window._paq.push(['setTrackerUrl', ${JSON.stringify(matomoPhp)}]);
    window._paq.push(['setSiteId', ${siteId}]);
    window._paq.push(['trackPageView']);
    window._paq.push(['enableLinkTracking']);
  <${'/'}script>
  <script type="text/plain" data-consent="statistics" data-src="${esc(matomoJs)}"><${'/'}script>`;
  }

  return '';
}
